import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";
import { GraphQL } from "@rpi/openapi-api";
import { Flex, RpiLink } from "@rpi/openapi-core";
import React from "react";
import { Body } from "../../../components/Typography";
import { formatDate } from "../../../utils/date.util";
import { UPLOADED_ON_PREFIX } from "./accountSettingsCopy";
import { TaxReviewStatusBadge } from "./TaxReviewStatusBadge";

export interface TaxExemptionDocument {
  id: number;
  fileName: string;
  url?: string | null;
  status: GraphQL.UploadedFileStatus;
  createdAt: string;
}

const useStyles = createStyles({
  subtle: { color: tokens.color.semantic.text.subtle },
  fileLink: { font: "inherit", color: "inherit", fontWeight: 600, textDecorationLine: "underline" },
});

interface TaxDocumentRowProps {
  taxDocument: TaxExemptionDocument;
  reviewStatus?: GraphQL.TaxReviewStatus | null;
}

function uploadedOnLabel(createdAt: string): string | null {
  const formattedDate = formatDate(createdAt);
  return formattedDate ? `${UPLOADED_ON_PREFIX}${formattedDate}` : null;
}

export const TaxDocumentRow: React.FC<TaxDocumentRowProps> = ({ taxDocument, reviewStatus }) => {
  const { classes } = useStyles();
  const uploadedLabel = uploadedOnLabel(taxDocument.createdAt);

  return (
    <Flex.Row
      align="center"
      justify="space-between"
      gap={16}
      fullWidth
      sx={{ flexWrap: "wrap" }}
      data-testid="tax-document-row"
    >
      <Body>
        {taxDocument.url ? (
          <RpiLink href={taxDocument.url} target="_blank" rel="noopener noreferrer" className={classes.fileLink}>
            {taxDocument.fileName}
          </RpiLink>
        ) : (
          taxDocument.fileName
        )}
      </Body>
      <Flex.Row align="center" gap={16}>
        {uploadedLabel && <Body className={classes.subtle}>{uploadedLabel}</Body>}
        {reviewStatus && <TaxReviewStatusBadge status={reviewStatus} />}
      </Flex.Row>
    </Flex.Row>
  );
};
